import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, filter } from 'rxjs';
import {
  catchError,
  mergeMap,
  withLatestFrom,
  map,
} from 'rxjs/operators';
import {
  DELIVERY_ZONE_FIND_ALL,
  DELIVERY_ZONE_FIND_ALL_SUCCESS,
  DELIVERY_ZONE_FAILURE,
  DELIVERY_ZONE_UPDATE_LOADING,
  DELIVERY_ZONE_FIND_BY_LOCATION,
  DELIVERY_ZONE_FIND_BY_LOCATION_SUCCESS,
  DELIVERY_ZONE_FIND_BY_LOCATION_FAILURE
} from '../actions';
import { ClientLocation, DeliveryZone } from '@core/models';
import { DeliveryZoneService } from '@core/services';
import { selectClientLocation, selectDeliveryZoneList, selectLocalChannelId } from '@store/selectors';
import { GeolocationService } from '@core/services/geolocation/geolocation.service';

@Injectable()
export class DeliveryZoneEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private deliveryZoneService: DeliveryZoneService,
    private geolocationService: GeolocationService
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DELIVERY_ZONE_FIND_ALL),
      withLatestFrom(this.store.select(selectLocalChannelId)),
      map(([_, localChannelId]) => {
        return {localChannelId: localChannelId as string}
      }),
      mergeMap(({ localChannelId }) => {
        this.store.dispatch(DELIVERY_ZONE_UPDATE_LOADING({ loading: true }));

        return this.deliveryZoneService.findAll(localChannelId).pipe(
          mergeMap(({ data }) => {
            const deliveryZoneList = data as DeliveryZone[];
            return [
              DELIVERY_ZONE_FIND_ALL_SUCCESS({ deliveryZoneList }),
              DELIVERY_ZONE_FIND_BY_LOCATION(),
              DELIVERY_ZONE_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => of(DELIVERY_ZONE_FAILURE({ error })))
        );
      })
    )
  );

  findDeliveryZoneByLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DELIVERY_ZONE_FIND_BY_LOCATION),
      withLatestFrom(
        this.store.select(selectClientLocation),
        this.store.select(selectDeliveryZoneList)
        ),
      filter(([_,location, deliveryZoneList]) => !!location && !!deliveryZoneList),
      map(([_,location, deliveryZoneList]) => {
        return {location: location as ClientLocation, deliveryZoneList: deliveryZoneList as DeliveryZone[] }
      }),
      map(({ location, deliveryZoneList }) => {

        const deliveryZone = deliveryZoneList.find(deliveryZone => this.geolocationService.isPointInShape(location, deliveryZone))

        if(deliveryZone){
          return DELIVERY_ZONE_FIND_BY_LOCATION_SUCCESS({ deliveryZone })
        }
        else{
          return DELIVERY_ZONE_FIND_BY_LOCATION_FAILURE({ error: 'No se encontró una zona de entrega' })
        }
      })
    )
  )
}
